import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  SxProps,
  Theme,
} from '@mui/material';

import { useLanguage } from '../../hooks';

const customStyles: Record<string, SxProps<Theme>> = {
  repeatedSections: {
    fontWeight: 'bold',
    color: 'red',
  },
  modalActions: {
    justifyContent: 'center',
  },
  confirmBtn: {
    textTransform: 'capitalize',
  },
};

interface RepeatedSectionsAlertProps {
  open: boolean;
  onClose: () => void;
  repeatedSections: string;
}

export const RepeatedSectionsAlert = ({
  open,
  onClose,
  repeatedSections,
}: RepeatedSectionsAlertProps) => {
  const lang = useLanguage();

  return (
    <Dialog
      open={open}
      maxWidth={'sm'}
      onClose={() => onClose()}
    >
      <DialogContent>
        <DialogContentText variant='h4'>{lang.form_builder.sectionNameAlert}</DialogContentText>
        <DialogContentText
          align='center'
          sx={customStyles.repeatedSections}
        >
          {repeatedSections}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={customStyles.modalActions}>
        <Button
          onClick={() => onClose()}
          color={'primary'}
          size={'small'}
          sx={customStyles.confirmBtn}
          variant={'outlined'}
        >
          {lang.form_builder.ok}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
